/*global google*/
import React, { useEffect, useState } from "react";
import { GoogleMap, InfoWindow, Marker, useLoadScript, MarkerClusterer } from "@react-google-maps/api";
import mapicon from "../../assets/images/mapicon.svg"
import mapicongreen from "../../assets/images/mapicongreen.svg"
const { googleMapsApiKey } = window.runConfig;
const markers = [
    {
        id: 1,
        name: "Chicago, Illinois",
        position: { lat: 41.881832, lng: -87.623177 }
    },
    {
        id: 2,
        name: "Denver, Colorado",
        position: { lat: 39.739235, lng: -104.99025 }
    },
    {
        id: 3,
        name: "Los Angeles, California",
        position: { lat: 34.052235, lng: -118.243683 }
    },
    {
        id: 4,
        name: "New York, New York",
        position: { lat: 40.712776, lng: -74.005974 }
    }
];

//const google=window.google
function Map({ scans, currentSelectState, }) {
    const [activeMarker, setActiveMarker] = useState(null);
    const [mapData, setMapData] = useState([])
    const handleActiveMarker = (marker) => {
        if (marker === activeMarker) {
            return;
        }
        setActiveMarker(marker);
    };

    const handleOnLoad = (map) => {
        const bounds = new google.maps.LatLngBounds();
        markers.forEach(({ position }) => bounds.extend(position));
        map.fitBounds(bounds);
    };
    useEffect(() => {
        let updatedScansData = scans.map((el) => ({
            ...el,
            newResult: el.result === "SUCCESS" ? "Pas" : el.result === "FAILED_TO_DECODE" ? "Fai" : "",
            className: el.result === "SUCCESS" || el.result === "FAILED_TO_DECODE" ? "my-marker-label-map" : "disbaled-map-marker",
            lat: parseFloat(el.latitude),
            lng: parseFloat(el.longitude)
        }))
        if (currentSelectState === "all") {
            setMapData(updatedScansData)
        } else if (currentSelectState === "success") {
            let newData = updatedScansData?.filter((el) => el.result === "SUCCESS")
            setMapData(newData)
        } else if (currentSelectState === "fail") {
            let newData = updatedScansData?.filter((el) => el.result === "FAILED_TO_DECODE")
            setMapData(newData)
        }
    }, [currentSelectState, scans])
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: googleMapsApiKey, // Add your API key
    });
    return (
        isLoaded && (<GoogleMap
            onLoad={handleOnLoad}
            onClick={() => setActiveMarker(null)}
            mapContainerStyle={{ width: "500px", height: "400px" }}
        >
            <MarkerClusterer imagePath="https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m" minimumClusterSize={2} gridSize={60} maxZoom={15} zoomOnClick={true}>
                {(clusterer) =>
                    mapData?.map(({ id, label, latitude, longitude, result, timestamp, newResult, className, lat, lng }) => (
                        <Marker
                            key={id}
                            position={{ lat: lat, lng: lng }}
                            onClick={() => handleActiveMarker(id)}
                            label={{
                                text: newResult,
                                className: className
                            }}
                            // label={{
                            //     text: result === "SUCCESS" ? "Pas" : result === "FAILED_TO_DECODE" ? "Fai" : "",
                            //     className: result === "SUCCESS" || result === "FAILED_TO_DECODE" ? "my-marker-label-map" : "disbaled-map-marker"
                            // }}
                            icon={{
                                url: result === "SUCCESS" ? mapicongreen : result === "FAILED_TO_DECODE" && mapicon,
                                scaledSize: new window.google.maps.Size(30, 30)
                            }}
                            clusterer={clusterer}
                        >
                            {activeMarker === id ? (
                                <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                                    <>
                                        <div>{id && "User ID: " + id}</div>
                                        <div>{label && "Projec name: " + label}</div>
                                        <div>{timestamp && "Time: " + timestamp}</div>
                                        <div>{result === "SUCCESS" ? "Scan status: Pass" : result === "FAILED_TO_DECODE" ? "Scan status: Fail" : ""}</div>

                                    </>
                                </InfoWindow>
                            ) : null}
                        </Marker>
                    ))
                }
            </MarkerClusterer>
        </GoogleMap>)

    );
}

export default Map;
